import { render, staticRenderFns } from "./stock-detail.vue?vue&type=template&id=26a1664c"
import script from "./stock-detail.vue?vue&type=script&lang=js"
export * from "./stock-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a1664c')) {
      api.createRecord('26a1664c', component.options)
    } else {
      api.reload('26a1664c', component.options)
    }
    module.hot.accept("./stock-detail.vue?vue&type=template&id=26a1664c", function () {
      api.rerender('26a1664c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Stock/stock-detail.vue"
export default component.exports